module.exports = __webpack_public_path__ + "img/delete_icon.621f5fbb.svg";